import { IntlShape } from 'react-intl';
import { ModuleHierachy } from '../../common/module/types';
import {
  AdminWalletPermissionType,
  WALLET_AWARD_NAMESPACE,
  WALLET_AWARD_PATH,
  WALLET_AWARD_TITLE,
  WALLET_BASE_PATH,
  WALLET_TITLE,
  WALLET_ASSIGNED_AWARD_NAMESPACE,
  WALLET_ASSIGNED_AWARD_TITLE,
  WALLET_ASSIGNED_AWARD_PATH,
  WALLET_BULKUPLOAD,
  WALLET_BULKUPLOAD_PATH,
  WALLET_BULKUPLOAD_UPLOAD,
  WALLET_BULKUPLOAD_UPLOAD_AWARD,
  WALLET_BULKUPLOAD_UPLOAD_AWARD_NAMESPACE,
  WALLET_BULKUPLOAD_UPLOAD_AWARD_PATH,
  WALLET_BULKUPLOAD_UPLOAD_PATH,
  WALLET_BULKUPLOAD_UPLOAD_STATUS,
  WALLET_BULKUPLOAD_UPLOAD_STATUS_NAMESPACE,
  WALLET_BULKUPLOAD_UPLOAD_STATUS_PATH,
  WALLET_BULKUPLOAD_UPLOAD_CREDIT,
  WALLET_BULKUPLOAD_UPLOAD_CREDIT_PATH,
  WALLET_BULKUPLOAD_UPLOAD_CREDIT_NAMESPACE,
  WALLET_CREDIT_PATH,
  WALLET_CREDIT_TITLE,
  WALLET_CREDIT_NAMESPACE,
} from './constants';
import { isPermitted } from 'src/app/common/utils';
import WalletAwardRoutes from './pages/Award/WalletAwardRoutes';
import WalletAssignedAwardRoutes from './pages/AssignedAward/AssignedAwardRoutes';
import BulkUploadCreditRoutes from './pages/BulkUpload/Upload/Credit/list/BulkUploadCreditRoutes';
import BulkUploadStatusRoutes from './pages/BulkUpload/Status/BulkUploadStatusRoutes';
import BulkUploadAwardRoutes from './pages/BulkUpload/Upload/Award/list/BulkUploadAwardRoutes';
import WalletCreditRoutes from './pages/Credit/WalletCreditRoutes';

export const walletModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });
  return {
    title: Translation(WALLET_TITLE),
    path: WALLET_BASE_PATH,
    icon: '/media/svg/icons/Home/Book-open.svg',
    enableRead: isPermitted(
      [
        AdminWalletPermissionType.WALLET_AWARD_READ,
        AdminWalletPermissionType.WALLET_AWARD_CREATE,
        AdminWalletPermissionType.WALLET_AWARD_UPDATE,
        AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_READ,
        AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_CREATE,
        AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_UPDATE,
        AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_CREATE,
        AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_READ,
        AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_UPDATE,
        AdminWalletPermissionType.WALLET_BULKUPLOAD_STATUS_READ,
      ],
      permissions,
    ),
    child: [
      {
        title: Translation(WALLET_AWARD_TITLE),
        path: `${WALLET_BASE_PATH}${WALLET_AWARD_PATH}`,
        namespace: WALLET_AWARD_NAMESPACE,
        component: WalletAwardRoutes,
        enableRead: isPermitted(
          [
            AdminWalletPermissionType.WALLET_AWARD_READ,
            AdminWalletPermissionType.WALLET_AWARD_CREATE,
            AdminWalletPermissionType.WALLET_AWARD_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminWalletPermissionType.WALLET_AWARD_CREATE], permissions),
        enableUpdate: isPermitted([AdminWalletPermissionType.WALLET_AWARD_UPDATE], permissions),
        enableApprove: isPermitted([AdminWalletPermissionType.WALLET_AWARD_APPROVE], permissions),
        options: {
          enableApprove: true,
        },
      },
      {
        title: Translation(WALLET_ASSIGNED_AWARD_TITLE),
        path: `${WALLET_BASE_PATH}${WALLET_ASSIGNED_AWARD_PATH}`,
        namespace: WALLET_ASSIGNED_AWARD_NAMESPACE,
        component: WalletAssignedAwardRoutes,
        enableRead: isPermitted(
          [
            AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_READ,
            AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_CREATE,
            AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_CREATE], permissions),
        enableUpdate: isPermitted([AdminWalletPermissionType.WALLET_ASSIGNED_AWARD_UPDATE], permissions),
      },
      {
        title: Translation(WALLET_CREDIT_TITLE),
        path: `${WALLET_BASE_PATH}${WALLET_CREDIT_PATH}`,
        namespace: WALLET_CREDIT_NAMESPACE,
        component: WalletCreditRoutes,
        enableRead: isPermitted([AdminWalletPermissionType.WALLET_CREDIT_READ], permissions),
      },
      {
        title: Translation(WALLET_BULKUPLOAD),
        path: `${WALLET_BASE_PATH}${WALLET_BULKUPLOAD_PATH}`,
        namespace: WALLET_AWARD_NAMESPACE,
        enableRead: isPermitted(
          [
            AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_CREATE,
            AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_READ,
            AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_UPDATE,
            AdminWalletPermissionType.WALLET_BULKUPLOAD_STATUS_READ,
            AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_CREATE,
            AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_READ,
            AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_UPDATE,
          ],
          permissions,
        ),
        child: [
          {
            title: Translation(WALLET_BULKUPLOAD_UPLOAD),
            path: `${WALLET_BASE_PATH}${WALLET_BULKUPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_PATH}`,
            enableRead: isPermitted(
              [
                AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_CREATE,
                AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_READ,
                AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_UPDATE,
              ],
              permissions,
            ),
            child: [
              {
                title: Translation(WALLET_BULKUPLOAD_UPLOAD_AWARD),
                path: `${WALLET_BASE_PATH}${WALLET_BULKUPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_AWARD_PATH}`,
                namespace: WALLET_BULKUPLOAD_UPLOAD_AWARD_NAMESPACE,
                component: BulkUploadAwardRoutes,
                enableRead: isPermitted(
                  [
                    AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_CREATE,
                    AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_READ,
                    AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_UPDATE,
                  ],
                  permissions,
                ),
                enableCreate: isPermitted(
                  [AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_CREATE],
                  permissions,
                ),
                enableUpdate: isPermitted(
                  [AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_AWARD_UPDATE],
                  permissions,
                ),
              },
              {
                title: Translation(WALLET_BULKUPLOAD_UPLOAD_CREDIT),
                path: `${WALLET_BASE_PATH}${WALLET_BULKUPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_CREDIT_PATH}`,
                namespace: WALLET_BULKUPLOAD_UPLOAD_CREDIT_NAMESPACE,
                component: BulkUploadCreditRoutes,
                enableRead: isPermitted(
                  [
                    AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_READ,
                    AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_CREATE,
                    AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_UPDATE,
                  ],
                  permissions,
                ),
                enableCreate: isPermitted(
                  [AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_CREATE],
                  permissions,
                ),
                enableUpdate: isPermitted(
                  [AdminWalletPermissionType.WALLET_BULKUPLOAD_UPLOAD_CREDIT_UPDATE],
                  permissions,
                ),
              },
            ],
          },
          {
            title: Translation(WALLET_BULKUPLOAD_UPLOAD_STATUS),
            path: `${WALLET_BASE_PATH}${WALLET_BULKUPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_STATUS_PATH}`,
            namespace: WALLET_BULKUPLOAD_UPLOAD_STATUS_NAMESPACE,
            component: BulkUploadStatusRoutes,
            enableRead: isPermitted([AdminWalletPermissionType.WALLET_BULKUPLOAD_STATUS_READ], permissions),
            enableApprove: isPermitted([AdminWalletPermissionType.WALLET_BULKUPLOAD_STATUS_APPROVE], permissions),
            options: {
              enableApprove: true,
            },
          },
        ],
      },
    ],
  };
};
